import * as React from 'react';
import styled from 'styled-components';
import Box from '@mui/material/Box';

const InputWrapper = styled(Box)`
  display: flex;
  gap: 24px;
  & > div {
    & > div:nth-of-type(2) {
      & > div:nth-of-type(1) {
        input {
          width: 40px;
        }
      }
    }
  }
`;

const StepperWrapper = styled(Box)`
  & > div {
    & > div {
      & > div:nth-of-type(1) {
        padding: 8px 2px;
        gap: 4px;
      }
      ,
      & > div:nth-of-type(2) {
        left: 20px;
      }
    }
  }
`;

export const CustomInputWrapper = (props) => {
  return <InputWrapper>{props.children}</InputWrapper>;
};

export const CustomStepperWrapper = (props) => {
  return <StepperWrapper>{props.children}</StepperWrapper>;
};
